const QrCodeEnum = {
  WEB_QR_CODE: {
    value: 0,
    label: 'web端二维码'
  },
  APP_QR_CODE: {
    value: 1,
    label: '移动端二维码'
  },
  MINI_APP_QR_CODE: {
    value: 2,
    label: '小程序二维码'
  }
};

export default QrCodeEnum;
